import clsx from 'clsx';
import React from 'react';

import { ILocationItemProps } from '@/modules/periodicJobs/components/LocationDropdown/LocationItem/ILocationItem';
import { Typography } from '@/shared/components/atoms';

import Check from '~/images/shared/CheckWithoudBg.svg';

const LocationItem: React.FC<ILocationItemProps> = ({
  children,
  onClick,
  selected,
}) => {
  const classNames = clsx(
    selected ? 'bg-primary-default' : '',
    'border-primary-default border-sm',
    'flex h-20 w-20 items-center justify-center rounded-sm'
  );

  return (
    <button
      onClick={onClick}
      className='flex w-full cursor-pointer items-center justify-between px-1.5 py-1'
    >
      <Typography component='h6' weight='semiBold'>
        {children}
      </Typography>
      <div className={classNames}>{selected && <Check />}</div>
    </button>
  );
};

export default LocationItem;
